import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import ScrollAdd from "../components/ScrollAdd";
import "../style.css";
import Slider from "../components/slider/Slider";
import FactSection from "../components/FactSection";
import { Button, Grid, Typography } from "@mui/material";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
// import FloatingEnrollButton from "../components/floatingenrollButton/FloatingEnrollButton";
import HiringPartners from "../components/HiringPartners";
import Animations from "../components/Animations";
import UpcomingEvent from "../Events/UpcomingEvent";
import Header from "../components/Header";

// import SpeedDialComponent from "../components/floatingenrollButton/SpeedDialComponent";

const Home = () => {
  const videoIds = [
    "p2rylmtKAts?si=afkRT_uZk9r1mBu8",
    "Tj93LsHSMGo?si=-B3Oh0-4ba5jekrG",
    "-EDimJYLAW8?si=uDa4UeYARl4AhraE",
    "ySuUPP18na8?si=YZkDlsGjgrqOVVyL",
  ];

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const animatables = document.querySelectorAll(".animatable");

      animatables.forEach((animatable) => {
        const elementTop = animatable.getBoundingClientRect().top + scrollY;
        const elementBottom = elementTop + animatable.clientHeight;

        // Check if element is in the viewport
        if (scrollY + windowHeight > elementTop && scrollY < elementBottom) {
          animatable.classList.add("animated");
          animatable.classList.remove("animatable");
        } else {
          // Reset the animation when the element is out of view
          animatable.classList.remove("animated");
          animatable.classList.add("animatable");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger animation on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [showButton, setShowButton] = useState(false);
  const [showTranslation, setShowTranslation] = useState(false);

  const handleMouseEnter = () => {
    setShowButton(true);
  };

  const handleMouseLeave = () => {
    setShowButton(false);
    setShowTranslation(false); // Hide translation on mouse leave
  };

  const handleTranslateClick = () => {
    setShowTranslation(true);
  };

  return (
    <>
      <ScrollAdd />
      <Navbar />
      {/* <FloatingEnrollButton /> */}
      {/* <SpeedDialComponent /> */}
      {/* <Slider /> */}
      <Header />
      <FactSection />

      <Grid container className="about-main-box block animatable bounceInLeft">
        {/* <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", padding: "5px" }}>
          <Typography style={{ textAlign: "justify" }}>
            <h1
              style={{
                margin: "auto",
                textAlign: "center",
                fontFamily: "Samarkan, sans-serif",
              }}
              id="font-color">
              Welcome to Learnorama Technologies
            </h1>
            <h3>Your Child's Learning Adventure Starts Here</h3>
            At <strong>Learnorama Technologies</strong>, we believe in nurturing
            young minds with{" "}
            <strong>innovative, technology-driven education</strong>. We offer a
            unique blend of{" "}
            <strong>online and offline learning experiences</strong> to prepare
            your child for the future. Our courses include cutting-edge
            technologies such as <strong>Artificial Intelligence (AI)</strong>{" "}
            and <strong>coding</strong>, as well as{" "}
            <strong>STEM education</strong>, alongside engaging{" "}
            <strong>art and science classes</strong>.
            <br />
            We also provide{" "}
            <strong>Artificial Intelligence-driven solutions</strong> for
            companies and organizations, including <strong>AI marketing</strong>
            , <strong>SEO</strong>, <strong>web design</strong>,{" "}
            <strong>content writing</strong>,{" "}
            <strong>marketing strategies</strong>, and{" "}
            <strong>product management</strong>. Our expertise empowers
            businesses to thrive in today's <strong>digital landscape</strong>.
            <br />
            But that's not all! We host{" "}
            <strong>adventure and life skills camps</strong>, fostering{" "}
            <strong>personal growth</strong>, <strong>confidence</strong>, and{" "}
            <strong>teamwork</strong>. In the 2025 academic year, we’re excited
            to introduce <strong>video-documented classes</strong> for the{" "}
            <strong>ICSE</strong> and <strong>CBSE curricula</strong>, providing
            a comprehensive and interactive learning platform for your child’s{" "}
            <strong>academic success</strong>.
          </Typography>
        </Grid> */}

        <Typography component="div" style={{ textAlign: "justify" }}>
          <h1
            style={{
              margin: "auto",
              textAlign: "center",
              fontFamily: "Samarkan, sans-serif",
            }}
            id="font-color">
            Welcome to Learnorama Technologies
          </h1>
          <h3>
            Empowering Young Minds through <br /> Artificial Intelligence and
            Digital Innovation
          </h3>
          <p>
            New Course Launch: <br />
            <strong>AI and Junior Prompt Engineering</strong>
          </p>
          <p>
            <strong>₹99</strong> only
          </p>
          <strong>✔ 45-minute video classes</strong> <br />
          <strong>✔ 99-page AI coursebook (digital copy)</strong>
          <br />
          <strong>
            ✔ Special training for schools, institutions, and college staff
          </strong>
          <p>
            <strong>Weekly Webinar</strong>: Every Wednesday, 7:30 PM to 8:30 PM
            – Live Q&A for students
          </p>
        </Typography>

        <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", textAlign: "center" }}>
          <div className="profile-wrapper" style={{ margin: "auto" }}>
            <div className="profile">
              <div className="profile-image">
                <img src="./images/ABOU-11.png" alt="About" />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <h1 className="event-title animatable bounceInRight">UPCOMING EVENT</h1>

      <div style={{display:'flex', margin:'auto', alignItems:'center', justifyContent:'center'}}>
      <div className="event-card">
                <img
                  src="./images/LEARNORAMA-LOGO.png"
                  alt="Tech Camp"
                  className="event-image"
                />
                <h2 className="event-heading">TECH GENERATION SUMMER CAMP 2025</h2>
                
                <Link to="/upcoming-event" className="styled-link">
                  <button className="button-2">Learn More</button>
                </Link>
              </div>
      </div> */}

      <UpcomingEvent />



      <Grid container className="about-main-box">
        <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", padding: "5px" }}>
          <Typography
            component="div"
            style={{ textAlign: "justify" }}
            className="block animatable bounceInLeft">
            <h2 id="font-color">Our Achievements:</h2>
            <p>✔ Students launched their own e-commerce websites</p>
            <p>✔ World record creators and breakers</p>
            <p>✔ Successfully organized the Tech Generation Summer Camp</p>


          </Typography>
        </Grid>

        <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", textAlign: "center" }}>
          <div
            className="profile-wrapper block animatable bounceInRight"
            style={{ margin: "auto" }}>
            <div className="profile">
              <div className="profile-image ">
                <img src="./images/homepg-22.jpg" alt="About" />
              </div>
            </div>
          </div>
          {/* <p className="tagline">
            "इस देश के हर कोने और हर घर तक एआई की शक्ति पहुंचाने के लिए सिर्फ 1
            रुपये में – हर छात्र के भविष्य को उज्जवल बनाने के लिए।"
          </p> */}

          <p
            className="tagline block animatable bounceInRight"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ position: "relative", display: "inline-block" }}>
            "इस देश के हर कोने और हर घर तक एआई की शक्ति पहुंचाने के लिए सिर्फ 99
            रुपये में – हर छात्र के भविष्य को उज्जवल बनाने के लिए।"
            {showButton && (
              <button
                onClick={handleTranslateClick}
                style={{
                  position: "absolute",
                  right: 0,
                  bottom: "100%",
                  backgroundColor: "#fd7e14",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}>
                Translate
              </button>
            )}
          </p>
          {showTranslation && (
            <p className="translation">
              "To bring the power of AI to every corner and every home in this
              country for just ₹99 – to brighten the future of every student."
            </p>
          )}

          <Link style={{ textDecoration: "none" }} to="/registration">
            <button
              style={{ marginTop: "15px", fontWeight: "bold" }}
              className="button-2 block animatable bounceInRight">
              Enroll Today
            </button>
          </Link>
        </Grid>
      </Grid>



      {/*youtube videos start  */}

      <Typography component="div">
        <h1
          style={{ margin: "auto", textAlign: "center" }}
          className="block animatable bounceInLeft">
          Latest News
        </h1>
      </Typography>

      <div className="Home-video-grid-main-box">
        <div className="Home-video-grid">
          {videoIds.map((id) => (
            <div className="Home-video-wrapper" key={id}>
              <iframe
                width="560"
                height="315"
                src={`https://www.youtube.com/embed/${id}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube video"></iframe>
            </div>
          ))}
        </div>
      </div>

      <HiringPartners />

      {/* youtube videos end  */}

      {/* ------------------------------------------------------------------- */}

      {/* contact start */}

      <Grid
        container
        className="about-main-box block animatable bounceInLeft"
        id="venue-box"
        style={{
          backgroundColor: "#000",
          padding: "20px 10px",
          borderRadius: "15px",
        }}>
        <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", padding: "5px" }}>
          <Typography
            component="div"
            style={{ textAlign: "center" }}
            className="heading-main-box">
            <h2 style={{ margin: "auto", textAlign: "center", color: "#000" }}>
              Contact Learn Orama Technologies PVT LTD
            </h2>
            <div className="contact-details">
              <p>
                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="mailto:info@learnorama.in">
                  <span>📧 Email:</span>info@learnorama.in
                </a>
              </p>
              <p>
                <p>
                  <a
                    style={{ textDecoration: "none", color: "#fff" }}
                    href="tel:+91 9849856143">
                    <span>☎️ Phone:</span>+91 9849856143{" "}
                    <span style={{ padding: "5px" }}>|</span>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "#fff" }}
                    href="tel:+91 9949567143">
                    +91 9949567143 <span style={{ padding: "5px" }}>|</span>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "#fff" }}
                    href="tel:+91 9959945143">
                    +91 9959945143
                  </a>
                </p>
              </p>
            </div>
            <p style={{ color: "#000" }} className="connect-message">
              Connect with us and give your child an unforgettable summer full
              of learning, growth, and fun!
            </p>
          </Typography>
        </Grid>

        <Grid
          item
          sm={12}
          md={6}
          lg={6}
          xl={6}
          style={{ margin: "auto", textAlign: "center" }}>
          <div className="profile-wrapper-contact" style={{ margin: "auto" }}>
            <div className="profile-contact">
              <div className="profile-image-contact">
                <img
                  style={{ width: "100%" }}
                  src="./images/contact-h1-01.png"
                  alt="About"
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* contact end */}

      {/* ------------------------------------------------------------------- */}

      {/* Footer */}

      <Footer />
    </>
  );
};

export default Home;
